import { CheckGateOptions } from "./types";

/**
 * Registry of all feature gates used in the application.
 * To add a new gate, simply add an entry to this map.
 */
export const GATES = {
  ENABLE_MODELING_LABS: {
    gateName: "enable_modeling_labs",
    fallback: false,
  },
  ENABLE_LEARNING_LABS: {
    gateName: "enable_learning_labs",
    fallback: false,
  },
  ENABLE_GRADED_LABS: {
    gateName: "enable_graded_labs",
    fallback: false,
  },
  ENABLE_STANDALONE_LABS: {
    gateName: "enable_standalone_labs",
    fallback: false,
  },
  ENABLE_PRACTICE_LABS: {
    gateName: "enable_practice_labs",
    fallback: false,
  },
  GET_ACCESS_FROM_ORDERS: {
    gateName: "get_access_from_orders",
    fallback: false,
  },
  ENABLE_SCORM_CONTENT: {
    gateName: "enable_scorm_content",
    fallback: false,
  },
  ENABLE_STORE_PROMOTIONS: {
    gateName: "enable_store_promotions",
    fallback: false,
  },
  ENABLE_GRADED_LABS_RETIRING: {
    gateName: "enable_graded_labs_retiring",
    fallback: false,
  },
  FILTERS_COLLAPSED_BY_DEFAULT: {
    gateName: "filters_collapsed_by_default",
    fallback: false,
  },
  ENABLE_DURATION_FILTER: {
    gateName: "enable_duration_filter",
    fallback: false,
  },
  ENABLE_COLLECTIONS_RETRIEVAL: {
    gateName: "enable_collections_retrieval",
    fallback: false,
  },
  ENABLE_EXAM_TOPICS_BLADE: {
    gateName: "enable_exam_topics_blade",
    fallback: false,
  },
  EMAIL_NOTIFICATION_OPT_IN: {
    gateName: "email_communication_opt_in",
    fallback: true,
  },
  ENABLE_MINDTICKLE_EXTERNAL_LAUNCH: {
    gateName: "enable_mindtickle_external_launch",
    fallback: false,
  },
} as const satisfies Record<string, CheckGateOptions>;

export type GateKey = keyof typeof GATES;
